import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Table, Checkbox, Modal, Button, Row, Col } from 'antd';
import { isMobile } from 'react-device-detect';
import { TableOutlined } from '@ant-design/icons';
import qs from 'qs';
import _ from 'lodash';
import { getListColumns, createColumns } from '@/redux/actions/UserColumnPreferencesActions';

class DynamicTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedColumns: props.columns.map(column => column.key),
            dataSource: props.dataSource || [],
            visible: false,
            extraQuery: {},
            urlSyncEnabled: true,
        };

        this.tableWrapperRef = createRef();
        this.scrollInterval = null;
    }

    // ===== Public API qua ref =====
    setExtraQuery = (obj = {}) => {
        this.setState(prev => ({ extraQuery: { ...prev.extraQuery, ...obj } }));
    };
    clearExtraQuery = () => this.setState({ extraQuery: {} });
    enableUrlSync = (bool = true) => this.setState({ urlSyncEnabled: !!bool });

    componentDidMount() {
        const { userId, moduleKey } = this.props;
        this.props.getListColumns({ user_id: userId, module_key: moduleKey }).then(res => {
            if (res && res.data.length > 0) {
                this.setState({ selectedColumns: res.data });
            }

        }).catch(err => {
            console.log(err)
        });

        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
        this.clearScrollInterval();
    }

    scrollBy = (distance) => {
        if (this.tableWrapperRef.current) {
            this.tableWrapperRef.current.querySelector('.ant-table-content').scrollBy({ left: distance, behavior: 'smooth' });
        }
    };

    handleKeyDown = (event) => {
        if (this.tableWrapperRef.current && !this.scrollInterval) {
            if (event.code === 'ArrowLeft') {
                event.preventDefault();
                this.clearScrollInterval();
                this.scrollBy(-200);
                this.scrollInterval = setInterval(() => {
                    this.scrollBy(-300);
                }, 300);
            } else if (event.code === 'ArrowRight') {
                event.preventDefault();
                this.clearScrollInterval();
                this.scrollBy(200);
                this.scrollInterval = setInterval(() => {
                    this.scrollBy(300);
                }, 300);
            }
        }
    };

    handleKeyUp = () => {
        this.clearScrollInterval();
    };

    clearScrollInterval = () => {
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }
    };

    handleColumnChange = (checkedValues) => {
        const { moduleKey } = this.props;
        this.setState({ selectedColumns: checkedValues });
        this.props.createColumns({ module_key: moduleKey, columns: checkedValues });
    };

    getRenderedColumns() {
        const { columns } = this.props;
        const { selectedColumns } = this.state;
        return columns.map(column => ({
            ...column,
            visible: selectedColumns.includes(column.key),
        })).filter(column => column.visible);
    }

    onClose() {
        this.setState({ visible: false });
    }

    // ===== Internal handleChangeTable (tự xử lý URL) =====
    handleChangeTable = (pagination, sorter, filters) => {
        const { history, location } = this.props; // from withRouter
        const { urlSyncEnabled, extraQuery } = this.state;

        if (!urlSyncEnabled || !history || !location) return;

        // parse query hiện tại từ URL
        const currentQuery = qs.parse(location.search, { ignoreQueryPrefix: true });

        let q = { ...currentQuery, ...extraQuery };

        // pagination
        if (!_.isEmpty(pagination)) {
            q.page = pagination.current;
            q.per_page = pagination.pageSize;
        }

        // sorter
        if (!_.isEmpty(sorter)) {
            if (sorter.order && sorter.field) {
                q.sort_field = sorter.field;
                q.sort_type = sorter.order === 'ascend' ? 'ASC' : 'DESC';
            } else {
                delete q.sort_field;
                delete q.sort_type;
            }
        }

        // (tuỳ chọn) merge thêm filters nếu bạn muốn chuẩn hoá
        // Object.entries(filters || {}).forEach(([k, v]) => {
        //   if (Array.isArray(v) && v.length) q[k] = v.join(',');
        //   else if (!v || (Array.isArray(v) && v.length === 0)) delete q[k];
        // });

        history.push({
            pathname: location.pathname,
            search: qs.stringify(q),
        });
    };

    static defaultProps = {
        columns: [],
        dataSource: [],
        isLoading: false,
        pagination: { currentPage: 1, total: 0, perPage: 30 },
        rowSelection: {},
        rowKey: 'id',
        className: '',
        summary: null,
        userId: null,
        moduleKey: null,
        rowClassName: null,
        getRowStyle: null,
    };

    render() {
        const { visible, selectedColumns } = this.state;
        const { columns, dataSource, isLoading, pagination, rowSelection, ref, rowKey, className, summary, buttonStyle, expandable, ...restProps } = this.props;

        const renderedColumns = this.getRenderedColumns();

        return (
            <div ref={this.tableWrapperRef}>
                <Button style={buttonStyle} onClick={() => this.setState({ visible: true })} className='custom-column-table-btn' size='small' icon={<TableOutlined />}>Cột</Button>
                <Table
                    rowKey={rowKey}
                    className={`table-striped-rows ${className}`}
                    size="small"
                    tableLayout='auto'
                    dataSource={dataSource || []}
                    columns={renderedColumns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    ref={ref}
                    summary={summary ? () => summary(renderedColumns) : undefined}
                    pagination={
                        pagination === false
                            ? false
                            : {
                                pageSize: pagination?.perPage ?? 30,
                                current: pagination?.currentPage ?? 1,
                                total: pagination?.total ?? 0,
                                showTotal: total => `Tổng ${total} bản ghi`,
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200'],
                            }
                    }
                    onChange={(pag, filters, sorter) => this.handleChangeTable(pag, sorter, filters)}
                    expandable={expandable}
                    scroll={{
                        x: 'max-content'
                    }}
                    rowClassName={(record, index) => {
                        // Nếu ngoài truyền hàm → dùng nó
                        if (typeof this.props.rowClassName === 'function') {
                            return this.props.rowClassName(record, index);
                        }
                        return '';
                    }}
                    onRow={(record, index) => {
                        const baseRow = {};

                        // style custom
                        if (typeof this.props.getRowStyle === 'function') {
                            baseRow.style = this.props.getRowStyle(record);
                        }

                        // nếu bên ngoài truyền vào onRow, merge lại
                        if (typeof this.props.onRow === 'function') {
                            const externalRow = this.props.onRow(record, index) || {};
                            return { ...baseRow, ...externalRow };
                        }

                        return baseRow;
                    }}
                    {...restProps}
                />

                <Modal
                    visible={visible}
                    title="Chọn cột hiển thị"
                    onCancel={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '55%'}
                    footer={false}
                >
                    <Checkbox.Group
                        value={selectedColumns}
                        onChange={this.handleColumnChange}
                    >
                        {/* <Space
                            wrap
                            size={[12, 12]}
                            align="start"
                        >
                            {columns.map(option => (
                                <Checkbox
                                    key={option.key}
                                    value={option.key}
                                    style={{
                                        margin: 0,
                                        whiteSpace: 'normal',
                                        lineHeight: '22px',
                                    }}
                                >
                                    {option.title}
                                </Checkbox>
                            ))}
                        </Space> */}
                        <Row>
                            {columns.map(option => (
                                <Col xs={24} md={8} key={option.key}>
                                    <Checkbox value={option.key}>{option.title}</Checkbox>
                                </Col>
                            ))}
                        </Row>
                    </Checkbox.Group>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        getListColumns: (filter) => dispatch(getListColumns(filter)),
        createColumns: (data) => dispatch(createColumns(data))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DynamicTable));

